document.addEventListener('DOMContentLoaded', () => {
	const headings = document.querySelectorAll('h1, h2, h3, h4, h5, h6');
	headings.forEach(heading => {
		const color = window.getComputedStyle(heading).color;
		const rgb = color.match(/\d+/g);
		let hexColor = color;
		if (rgb && rgb.length >= 3) {
			hexColor = "#" + rgb.slice(0, 3).map(x => {
				const hex = parseInt(x).toString(16);
				return hex.length === 1 ? "0" + hex : hex;
			}).join('');
		}
		if (! heading.classList.contains('plain-heading')) {
			heading.classList.add(('#ffffff' === hexColor.toLowerCase()) ? 'bko-heading-white' : 'bko-heading-blue');
		}
	});
});
